import BaseApi from '../BaseApi';
import { ReportsApiConverter } from './ReportsApiConverter';

class ReportsApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin/user`;
    this.baseUrl2 = `${baseUrl}/api/agent_admin`;
    this.converter = new ReportsApiConverter();
  }

  getStatisticProvider = ({ id, requestedBody /* , isOutdated = false */ }) =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/${id}/statistic/provider/`, requestedBody, null, data =>
      this.converter.convertStatisticProvider(data /* , isOutdated */),
    );

  getStatisticProviderTimeseries = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/statistic/provider/timeseries`,
      requestedBody,
      null,
      this.converter.convertTimeseries,
    );

  getProviderRanks = ({ id, provider, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/statistic/provider/${encodeURIComponent(provider)}/ranks`,
      requestedBody,
      null,
      this.converter.convertProviderRanks,
    );

  getProviderTimeseries = ({ id, provider, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/statistic/provider/${encodeURIComponent(provider)}/timeseries`,
      requestedBody,
      null,
      this.converter.convertTimeseries,
    );

  getStatisticFilters = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl2}/statistic/filters/list`,
      null,
      null,
      this.converter.convertStatisticFilters,
    );

  createStatisticFilter = requestedBody =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl2}/statistic/filters`,
      requestedBody,
      null,
      this.converter.convertStatisticFilter,
    );

  updateStatisticFilter = requestedBody =>
    this.sendQuery(
      this.queryTypes.PATCH,
      `${this.baseUrl2}/statistic/filters`,
      requestedBody,
      null,
      this.converter.convertStatisticFilter,
    );

  deleteStatisticFilter = id =>
    this.sendQuery(this.queryTypes.DELETE, `${this.baseUrl2}/statistic/filters`, { id });

  getPaymentHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/payment/history/`,
      requestedBody,
      null,
      this.converter.convertPaymentHistory,
    );

  getPaymentHistoryTotals = ({ id, requestedBody }) => {
    return this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/payment/history/`,
      requestedBody,
      null,
      this.converter.convertPaymentHistoryTotals,
    );
  };

  getStatisticPlayer = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/statistic/player/`,
      requestedBody,
      null,
      this.converter.convertStatisticPlayer,
    );

  getSlotsHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/slots/history/`,
      requestedBody,
      null,
      this.converter.convertSlotsHistory,
    );

  getBetsHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/bets/history/`,
      requestedBody,
      null,
      this.converter.convertBetsHistory,
    );

  getFinanceHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/finance/history/`,
      requestedBody,
      null,
      this.converter.convertFinanceHistory,
    );

  getBetInfo = ({ userId, betId }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${userId}/slots/history/bet/${betId}/`,
      null,
      null,
      this.converter.convertBetInfo,
    );

  getRequestHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl2}/payment/requests/history/`,
      requestedBody,
      null,
      this.converter.convertRequestHistory,
    );
}

export default ReportsApi;
